countries = {
	"Afghanistan" : {
		"disabled" : false,
		"active_fill" : "#000000",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Afghanistan.pdf",
		"bullets" : [
			"2,367 people (513 women) received services through the Legal Aid Grant Facility, exceeding the annual target.",
			"242 policewomen benefitted from training at the Sivas Police Training Academy in Turkey and 20 policewomen completed the Training of Trainers programme and started a new training class of 168 policewomen",
			"The Support to Payroll Management Project made advances to the Ministry of Finance for the payment of salaries to the Ministry of Interior Affairs, Afghanistan National Police, and the General Directorate of Prisons and Detention Centers amounting to $311,732,028 (USD) between January-November 2018. "
		]
	},
	"Bosnia-Herzegovina" : {
		"disabled" : false,
		"active_fill" : "#0f1cba",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Bosnia-Herzegovina.pdf",
		"bullets" : [
			"22,727 free legal aid services were provided to a total of 17,598 beneficiaries (8,700 women).",
			"2 resource packages and training tools developed on the provision of conflict-related sexual violence services and protocols, including Training of Trainers modules for free legal aid providers."

		]
	},
	"Bangladesh" : {
		"disabled" :false,
		"active_fill" : "#ff9900",
		"link" : "https://www.undp.org/",
		"bullets" : [
			"14 Community Policing Forums activated with 1,240 members trained to reduce crime and contribute to peaceful co-existence in Ukhia and Teknaf districts in Cox’s Bazar. ",
			"70 policewomen oriented on the community policing strategy and police facilities rehabilitated to encourage women’s participation and to prevent sexual harassment and gender-based violence.",
			"2 Local Mediator Volunteer Forums formed to resolve community disputes and foster cohesion and 80 volunteers trained on mediation skills, resolving 27 disputes."
		]
	},
	"Burkina_Faso" : {
		"disabled" : false,
		"active_fill" : "#45907C",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-BurkinaFaso.pdf",
		"bullets" : [
			"144 gendarmes (25 women) and 104 police officers (12 women) working in the Sahel region trained on human rights in the fight against violent extremism.",
			"114 people accused of crimes and held in pretrial detention (some for more than 14 years) saw their cases commence in court and received judgment.",
			"25 members of legal aid committees received training and provided assistance to 274 people."
		]
	},
	"Burundi" : {
		"disabled" : false,
		"active_fill" : "#0B5453",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Burundi.pdf",
		"bullets" : [
			"1,329 women and 4,478 men informed of tools and mechanisms to claim their rights, leading to an increase in demand for legal aid service by 23% over the course of the year.",
			"260 convicted prisoners, including 57 women and 203 men in pilot prisons in Ngozi, Gitega, and Rumonge, benefited from vocational training to support socio-economic reintegration.",
			"4,000 women recovered their land rights as a result of increased efficiency in the judicial system in 14 provinces."
			
		]
	},
	"Central_African_Republic" : {
		"disabled" : false,
		"active_fill" : "#A33440",
		"link":"#",
		"bullets" : [
			"The Special Criminal Court held its inaugural session, launching the investigation phase of serious crimes and human rights violations committed since 2003.",
			"Legal aid clinics provided assistance to 10,792 people, including 2,856 survivors of sexual and gender-based violence (SGBV).",
			"500 newly recruited police officers and gendarmes graduated from training, helping to professionalize and expand state presence throughout the country."
		]
	},
	"Colombia" : {
		"disabled" : false,
		"active_fill" : "#A68E84",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Colombia.pdf",
		"bullets" : [
			"The rights to reparation of 41,459 victims of the armed conflict in 11 regions fulfilled through 110 initiatives in 26 collective reparation communities, indirectly benefitting over 710,000 people.",
			"Over 2,700 relatives of victims of enforced disappearances supported in case documentation and submitting information to responsible state institutions.",
			"13 Local Justice Systems established in 4 regions of the country, benefitting 9,800 residents of conflict-afflicted municipalities.",
			"6,650 people in 65 municipalities supported through the Ombudsman's Office to request the attention of the state and the enforceability of rights, demand inter-institutional coordination to address real or potential violations of human rights, and mitigate humanitarian crises."
		]
	},
	"Côte_d’Ivoire" : {
		"disabled" : false,
		"active_fill" : "#464D87",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-CoteDIvoire.pdf",
		"bullets" : [
			"Enhanced support for gender-based violence victims through the establishment of 12 new gender desks in police stations, the installation of 3 new legal clinics, and the training of 76 Judicial Police Officers, and 37 Military Legal Advisers.",
			"Strengthened disarmament, demobilization, and reintegration efforts through increased public awareness, the collection of 914 weapons, 105 ammunitions, and 5 grenades, and the training of 400 ex-combatants that have been integrated into public administration.",
			"5 new civil-military committees installed and socio-security diagnoses conducted in 10 localities, improving trust between people and the defense and security forces."

		]
	},
	"Democratic_Republic_of_the_Congo" : {
		"disabled" : false,
		"active_fill" : "#464D87",
		"link" : "#",
		"bullets" : [
			"12 investigations and 17 mobile court hearings resulted in the adjudication of 85 international criminal cases.",
			"758 prisoners of Goma, Bukavu, and Bunia benefited from legal assistance, leading to the release of 454 illegally detained prisoners and reducing the rate of pretrial detention by 36%.",
			"From 2015 to 2018, 4,987 survivors of sexual violence benefited from legal assistance, which led to 2,661 judicial decisions."
		]
	},
	"El_Salvador" : {
		"disabled" : false,
		"active_fill" : "#902C34",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-ElSalvador.pdf",
		"bullets" : [
			"The first monitoring report of the El Salvador Seguro Plan (2016-2017) produced, providing evidence-based information across 80 indicators of progress in 21 result areas. ",
			"Since 2015, homicides in El Salvador have been reduced by 49.3%, with a marked reduction in municipalities prioritized by the El Salvador Seguro Plan.",
			"The National Council for Citizen Security and Coexistence updated the El Salvador Seguro Plan (2014-2024) to form a comprehensive package of public policies on citizen security, which are being implemented in 50 municipalities."
		]
	},
	"The_Gambia" : {
		"disabled" : false,
		"active_fill" : "#902C34",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Gambia.pdf",
		"bullets" : [
			"A National Security Policy and a National Strategy for Transitional Justice developed through participatory and inclusive processes to guide security and justice reforms for the country.",
			"The Truth, Reconciliation, and Reparations Commission launched, with 11 Commissioners (4 women) and 85 staff members.",
			"A National Human Rights Commission established, with operations expected to begin in 2019."
		]
	},
	"Guatemala" : {
		"disabled" : false,
		"active_fill" : "#7C3281",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Guatemala.pdf",
		"bullets" : [
			"More than 3,000 victims of the internal armed conflict supported in accessing justice, truth, and reparations.",
			"The Directorate of Criminal Analysis’ coverage was extended to 9 public prosecutor's offices in the interior of the country, generating 63 criminal analysis reports related to 13,400 cases.",
			"The anti-corruption legal assistance mechanism received 478 complaints from civil society, which are being processed in accordance with the Comprehensive Care Guide on Corruption Cases. "
		]
	},
	"Guinea_(Conakry)" : {
		"disabled" : false,
		"active_fill" : "#8C9843",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-GuineaConakry.pdf",
		"bullets" : [
			"Criminal justice response increased by 70% in 2018, with 1,778 criminal cases adjudicated that led to the release of 996 people (97 women and 17 minors) held in pre-trial detention.",
			"Coordination and oversight mechanisms of the criminal justice chain established in all 5 pilot district courts.",
			"Improved judiciary and penitentiary governance through building the capacity of 90% of the investigating judges in Guinea and the drafting of 21 key legislations to implement the Code of Criminal Proceedings."
		]
	},
	"Guinea-Bissau" : {
		"disabled" : false,
		"active_fill" : "#8E967D",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-GuineaBissau.pdf",
		"bullets" : [
			"Access to justice improved through infrastructure development, the provision of free legal aid to over 2,000 individuals, and specialized training of over 100 new lawyers.",
			"National Criminal Records Database developed to track precise criminal background information of individuals,  strengthening national and international security.",
			"Justice and Human Rights Thematic Group established to enhance coordination of the justice reform process with the Ministry of Justice and Human Rights and other stakeholders."
		]
	},
	"Haiti" : {
		"disabled" : false,
		"active_fill" : "#946F2C",
		"link" : "#",
		"bullets" : [
			"The Haitian National Police implemented a case management system and received specialized training (200 officers) to combat impunity, corruption, and safeguard human rights.",
			"3 police commissariats in Grande Anse and West provinces and 2 regional offices of the Ombudsman’s Office in Saint Marc and Jeremie were established or rehabilitated.",
			"The Inter-Ministerial Committee for Human Rights drafted a national action plan for the implementation of recommendations made by the Universal Periodic Review and Committee on the Elimination of Discrimination against Women."
			]
	},
	"Iraq" : {
		"disabled" : false,
		"active_fill" : "#8BA466",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Iraq.pdf",
		"bullets" : [
			"A total of 943 displaced people (800 women and 143 men) received SGBV protection services made available by the Directorate for Violence Against Women (DCVAW) in 5 internally displaced person and refugee camp centres in Sulaimaniya, Erbil, and Dohuk.",
			"6 DCVAW Reconciliation Committees restored in Erbil, Sulaimaniya, Duhok, Garmyan, Raparin, and Soran, resolving 660 cases of domestic violence.",
			"A total of 211 DCVAW staff (188 women and 23 men) were trained on SGBV case handling and awareness raising to prevent and respond to SGBV."
		]
	},
	"Jordan" : {
		"disabled" : false,
		"active_fill" : "#84709C",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Jordan.pdf",
		"bullets" : [
			"17 youth Ambassadors received training to effectively interact with police officers on community safety issues.",
			"15 Jordanian representatives from justice and security institutions attended international conferences to exchange lessons learned on legal aid, community policing, and gender justice."
		]
	},
	"Kosovo_(UN_Administered_Territory)" : {
		"alt_title" : "KOSOVO (UN Administered Territory)",
		"disabled" : false,
		"active_fill" : "#9157A4",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Kosovo.pdf",
		"bullets" : [
			"4 Municipal Action Plans on gender-based violence and domestic violence were updated to take forward the National Strategy for Protection against Domestic Violence in alignment with international standards.",
			"4,924 (47 % women) people benefitted from legal aid services, reflecting an 18% increase from 2017.",
			"Court backlog decreased by 22% in the first and second instance courts, from 286,464 cases in 2017 to 235,408 in 2018."
		]
	},
	"Kyrgyz_Republic" : {
		"disabled" : false,
		"active_fill" : "#902C34",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-KyrgyzRepublic.pdf",
		"bullets" : [
			"Public monitoring conducted in 9 prison facilities to assess social reintegration-related needs of inmates who have been convicted of violent extremism and inform future rehabilitation measures.",
			"9,489 people, including 4,656 women and 601 persons with disabilities, received legal assistance and information from the Ministry of Justice Free Legal Aid Centers and the Bus of Solidarity.",
			"A package of 8 criminal justice laws and codes were developed and will be enacted in 2019."
			]
	},
	"Lebanon" : {
		"disabled" : false,
		"active_fill" : "#6D2882",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Lebanon.pdf",
		"bullets" : [
			"143 municipal police officers from 14 municipalities received training on providing people-centred security services from the Internal Security Forces Academy. ",
			"Rehabilitation efforts at Roumieh and Baabda prisons improved conditions for 3,545 detainees, protecting their basic human rights. ",
			"93% of municipalities provided biannual data to inform Syrian crisis response efforts."
			]
	},
	"Liberia" : {
		"disabled" : false,
		"active_fill" : "#368739",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Liberia.pdf",
		"bullets" : [
			"6 prosecutors, 2 victim support officers, 60 judges, 6 public defenders, and 10 human rights monitors recruited, trained, and deployed to remote parts of the country",
			"2 sets of shadow reports from civil society were submitted to the Human Rights Council and the Committee on the Rights of Persons with Disabilities ",
			"44 high-level representatives from the main political parties benefited from tailored human rights training",
			"Regulatory framework developed on the newly established Civilian Complaints Review Boards for the National Police and Immigration Service",
			"A specialized SGBV court established in Nimba County to improve access to appropriate justice and security services",
			"74 civil society organizations launched an initiative to provide legal aid and assistance to socially disadvantaged groups and increase legal literacy"
		]
	},
	"Libya" : {
		"disabled" : false,
		"active_fill" : "#0B5453",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Libya.pdf",
		"bullets" : [
			"The first group of the 134 newly trained police officers were deployed and the first model police station was inaugurated, increasing police presence in the streets of Tripoli to better serve the Libyan population. ",
			"Capacity development support was provided to the police and judicial police including through revision of training curricula, conducting human rights training, rehabilitating training facilities, facilitating Training of Trainers for 40 police and 18 judicial police officers, and undertaking a training programme for 1,500 police officers and 330 judicial police officers.",
			"A psychosocial support centre rehabilitated in Tomina to support the conflict-affected Tawergha and Misrata communities and renew community dialogue, focusing on human rights and humanitarian grievances."
		]
	},
	"Mali" : {
		"disabled" : false,
		"active_fill" : "#0C793B",
		"link" : "#",
		"bullets" : [
			"449 corrections administration personnel trained on United Nations Guidelines for the treatment of prisoners",
			"398 inmates gained technical skills allowing for social reintegration.",
			"611 female prisoners received dignity kits to improve their detention conditions."
		]
	},
	"Myanmar" : {
		"disabled" : false,
		"active_fill" : "#205EBB",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Myanmar.pdf",
		"bullets" : [
			"Guidance manual on Housing Land and Property laws and issues developed for local legal aid providers.",
			"The Attorney General’s Office’s Fair Trial Manual was produced and disseminated to over 5,000 criminal justice stakeholders through regional sessions.",
			"Capacity assessment of the Myanmar National Human Rights Commission completed, identifying strengths and areas for improvement."
		]
	},
	"Nepal" : {
		"disabled" : false,
		"active_fill" : "#957726",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Nepal.pdf",
		"bullets" : [
			"16 laws related to fundamental rights passed by the Parliament.",
			"Pro bono guidelines for lawyers adopted, which will help to increase the number of recipients of free legal aid in Nepal.",
			"187 mediators (57 women) trained and placed on the roster of mediators supporting the work of local Judicial Committees."
		]
	},
	"Nigeria" : {
		"disabled" : false,
		"active_fill" : "#957726",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Nigeria.pdf",
		"bullets" : [
			"99 people, including traditional and religious leaders, paralegals, and lawyers from conflict-affected communities, trained on establishing referral services for people to access justice through Training of Trainers sessions.",
			"40 health care providers from conflict-affected communities trained on the proper screening of victims of sexual and gender-based violence and administration of post-exposure prophylaxis and HIV Kits."
		]
	},
	"Pakistan" : {
		"disabled" : false,
		"active_fill" : "#707D6B",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Pakistan.pdf",
		"bullets" : [
			"1,067 people (616 women) received legal aid services and 8,744 people (4,636 women) accessed legal awareness campaigns and mobile legal aid clinics.",
			"25 Model Police Stations were established to deliver people-centred and gender-responsive services to the population, including the training of 144 police officials (30 women) and the development of 5 sets of policing software.",
			"A forum of female lawyers was established in Khyber Pakhtunkhwa, with an initial membership of 125 women."
		]
	},
	"Sierra_Leone" : {
		"disabled" : false,
		"active_fill" : "#638A26",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-SierraLeone.pdf",
		"bullets" : [
			"Bail Regulations passed into law by Parliament and 2 correctional laws submitted for Cabinet clearance and Parliament enactment in 2019.",
			"Prison Courts held 11 sessions, reviewing more than 1,000 criminal cases, which led to 421 indictments, the provision of legal assistance to 650 defendants, and the immediate release and acquittal of 24 defendants subjected to prolonged pretrial detention.",
			"241 inmates (31 women) have been enrolled in the Inmates Earning Scheme in a variety of roles such as tailoring, agriculture, and metal and wood work."
		]
	},
	"Somalia" : {
		"disabled" : false,
		"active_fill" : "#543887",
		"link" : "#",
		"bullets" : [
			"242 students were supported with scholarships and 119 were supported with internships, contributing to the development of a capable and well-functioning justice sector.",
			"Mobile courts are operating in all 5 Federal Member States of Somalia and Somaliland and processed a total of 1,416 cases.",
			"4 new Community Dispute Resolution centres opened in Jubaland and South West States, bringing the total number of centres to 11 across 4 Federal Member States, which resolved a total of 3,364 cases throughout the year."
		]
	},
	"South_Sudan" : {
		"disabled" : false,
		"active_fill" : "#A68E84",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-SouthSudan.pdf",
		"bullets" : [
			"3,971 people (1,722 women) accessed legal aid services through the Justice and Confidence Centers in 4 locations.",
			"The police responded to 10,279 calls made to the Emergency Call Center. ",
			"Mobile courts across 9 locations processed 273 backlogged cases."
		]
	},
	"Sri_Lanka" : {
		"disabled" : false,
		"active_fill" : "#8F9326",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-SriLanka.pdf",
		"bullets" : [
			"The Right to Information Commission, the National Police Commission, and the Human Rights Commission of Sri Lanka demonstrated increased efficiency.",
			"13 civil society organizations and victim groups created a community platform to amplify the voice of victims, build capacity, empower victims to engage in transitional justice processes, and strengthen outreach and communication efforts to keep victims informed.",
			"400 stakeholders received training on the National Victim and Witness Protection Act, including police officers from 8 provinces, Police Protection Division officers, private bar members, legal aid officers, and judicial medical officers."
		]
	},
	"State_of_Palestine" : {
		"disabled" : false,
		"active_fill" : "#B31F9B",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-StateOfPalestine.pdf",
		"bullets" : [
			"Approximately 10,316 people (including 3,129 women and 2,906 children) benefited from legal services across the West Bank and Gaza.",
			"The National Legal Aid Strategy was adopted, providing for the establishment of a national legal aid institution in charge of providing free legal aid to the vulnerable population.",
			"An e-learning portal of the Palestinian Judicial Institute was developed, enabling on-line training for all Palestinian judges and prosecutors."
		]
	},
	"Sudan" : {
		"disabled" : false,
		"active_fill" : "#1C8B87",
		"link" : "#",
		"bullets" : [
			"Extensive capacity building training provided to 2,191 people (1,036 women) from the justice and security sectors (police, lawyers, judges, paralegals, law makers, and native administrations) as well as internally displaced persons and civil society across Darfur.",
			"3 rural courts, 1 training police facility, and 1 Family and Child Protection Unit established in Darfur.",
			"A land dispute resolution system created for Darfur, connecting existing community reconciliation mechanisms in 63 out of 64 localities, state-level arbitration teams, and the Special Prosecutor on Land Tenure in the Ministry of Justice."
		]
	},
	"Syria" : {
		"disabled" : false,
		"active_fill" : "#1C8B87",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Syria.pdf",
		"bullets" : [
			"6 area-based assessments informed the implementation of 10 community security initiatives, which involved installing 61 solar lighting systems, establishing a community mediation committee in Qamishli, and strengthening the conflict resolution skills of 40 community leaders and communication skills of 30 youth.",
			"At least 70 cases were referred to external service providers for judicial representation through three newly established legal counselling and referral help desks. ",
			"Over 2,500 people (65% women) were reached through 8 community-based legal awareness initiatives focused on women’s rights and 20 publications, brochures, and documentary films were produced and disseminated, tackling various topics such as inequality before the law between men and women, right of maintenance, forced marriage, etc."
		]
	},
	"Timor-Leste" : {
		"disabled" : false,
		"active_fill" : "#3B82B9",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-TimorLeste.pdf",
		"bullets" : [
			"13 trainees (1 woman) of the 6th Course for Magistrates and Public Defenders progressed to the final internship phase, and 29 trainees (5 women) of the 5th Course for Private Lawyers were accredited by the Legal and Judicial Training Center.",
			"Mobile courts received 708 cases, out of which 332 cases (329 criminal and 3 civil) were adjudicated, benefitting approximately 689 people (260 women) including 197 gender-based violence survivors.",
			"Access to Justice Clinics enabled 140 people (30 women) residing in rural areas to access free legal aid and reached 2,845 people (968 women) through awareness-raising campaigns and alternative dispute resolution training."
		]
	},
	"Tunisia" : {
		"disabled" : false,
		"active_fill" : "#0B786C",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Tunisia.pdf",
		"bullets" : [
			"71 judges, 16 prosecutors, 24 court clerks, and 85 lawyers from specialized chambers for serious crimes were trained on transitional justice and the protection of victims and witnesses.",
			"The Truth and Dignity Commission completed its mandate and transferred 34 cases to the 13 specialised chambers, out of which 23 are adjudicated.",
			"113 people (63 women) benefited from a services, such as assistance and representation, and 137 people (75 women) benefited from a legal aid service."
		]
	},
	"Ukraine" : {
		"disabled" : false,
		"active_fill" : "#74E378",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Ukraine.pdf",
		"bullets" : [
			"The Ombudsperson’s Office regional network expanded from 3 to all 24 regions, including as national preventative mechanisms (Ombudsman-Plus) and in Crimea and non-government-controlled areas.",
			"48,946 people (62% women) received free legal advice at local centres and bureaus in Donetsk, Luhansk, and Zhytomyr oblasts and the awareness of free legal aid services among the conflict-affected population increased from 27.6% in 2017 to 36.7% in 2018.",
			"Over 700,000 people, including 25,000 people with disabilities and limited mobility gained access to social services and employment and more than 473,000 people learned about the mechanisms for ensuring accessibility and Universal Design Principles through public awareness campaigns."
		]
	},
	"Yemen" : {
		"disabled" : false,
		"active_fill" : "#0C793B",
		"link" : "http://www.undp.org/content/dam/undp/library/Democratic%20Governance/ROL_AR2017/UNDP-2017-CountryProfile-Yemen.pdf",
		"bullets" : [
			"A committee was established to provide legal aid services for children in conflict and handled 60 cases (51 boys and 9 girls).",
			"Prison conditions in Sana’a and Aden improved for 200 detainees, including 40 people with disabilities.",
			"Rule of law, police, and prisons assessments to establish baselines and identify priorities for support were carried out in 8 cities (Sana’a, Ibb, Hadramowt, Hodeidah, Aden, Lahj, Shabwa, and Tai’z) and 5 prisons (Sana’a, Aden, Ibb, Lahj, Dhamar)."
		]
	},
	"Zimbabwe" : {
		"disabled" :false,
		"active_fill" : "#006400",
		"link" : "https://www.undp.org/",
		"bullets" : [
			"Zimbabwe’s 5-year National Peace and Reconciliation Strategic Plan was adopted at a high-level stakeholder conference. ",
			"The Strategic Plan was developed through an inclusive and participatory process, with citizen consultations in 10 provinces and 1,800 stakeholders engaged directly across the country.",
			"Key mechanisms for implementation of the strategy were developed, including the establishment of committees on Victim Support, Gender and Diversity, Prevention and Non-Recurrence, Complaints Handling, Healing and Reconciliation, and Research and Knowledge Management."
		]
	},
};



/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = countries;
